import setSuperAdmins from './setSuperAdmins';
import setSuperAdmin from './setSuperAdmin';

export default { setSuperAdmins, setSuperAdmin };
